import { PublicClientApplication, type Configuration } from '@azure/msal-browser';
import { config } from '../config';

const msalConfig: Configuration = {
  auth: {
    clientId: config.entra.clientId,
    authority: `https://login.microsoftonline.com/${config.entra.tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

/** Scopes requested when acquiring a token for the Forms API. */
export const apiRequest = {
  scopes: config.entra.apiScope ? [config.entra.apiScope] : [],
};

/** Interactive sign-in request. */
export const loginRequest = {
  scopes: ['openid', 'profile', ...apiRequest.scopes],
};

/**
 * Acquires an access token for the Forms API, silently if possible.
 * Throws if no account is signed in.
 */
export async function getAccessToken(): Promise<string> {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) {
    throw new Error('No signed-in account.');
  }

  try {
    const result = await msalInstance.acquireTokenSilent({ ...apiRequest, account });
    return result.accessToken;
  } catch {
    // Silent renewal fails once the SPA refresh token expires (~24h) or when the browser
    // blocks the third-party cookie used by the iframe (monitor_window_timeout). Fall back
    // to an interactive redirect to re-establish the session; the app reloads afterwards.
    await msalInstance.acquireTokenRedirect({ ...apiRequest, account });
    throw new Error('Redirecting to sign in…');
  }
}
